import { RadioOption } from 'src/components/atoms'
import { Option } from 'src/components/molecules/SelectWithOption'
import {
  ReportTypeEnum,
  TenantRegisterCategoryEnum,
} from 'src/slices/services/api'
import { ReportCycleEnum } from './type'

export const reportTypeOption: RadioOption[] = [
  { label: 'CCT報告', value: ReportTypeEnum.Cct },
  { label: 'オフライン報告', value: ReportTypeEnum.Offline },
]

export const registerCategoryOption: RadioOption[] = [
  {
    label: '代表レジとして登録する',
    value: TenantRegisterCategoryEnum.RepresentativeRegister,
  },
  { label: 'その他レジ', value: TenantRegisterCategoryEnum.OtherRegisters },
]

export const reportCycleOption: Option[] = [
  { title: '毎月', value: ReportCycleEnum.isMonthlyReport },
  { title: '毎日', value: ReportCycleEnum.isDailyReport },
]

export const convertReportCycleToValue = (
  isMonthlyReport?: boolean
): ReportCycleEnum => {
  return isMonthlyReport
    ? ReportCycleEnum.isMonthlyReport
    : ReportCycleEnum.isDailyReport
}
